/*
 * @Descripttion: 
 * @version: 
 * @@Company: HDWB
 * @Author: cwl
 * @Date: 2022-04-12 17:28:44
 * @LastEditors: cwl
 * @LastEditTime: 2022-05-10 09:43:47
 */
/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * 
 */

let baseUrl = '';
let routerMode = 'history';
let imgBaseUrl = '';
const BASEURL = process.env.VUE_APP_BASE_URL
const IMG_BASE_URL = process.env.VUE_APP_IMG_BASE_URL

// 192.168 .10 .158: 8217
// 
// console.log('before=======' + process.env.NODE_ENV)

// if (process.env.NODE_ENV == 'development') {
//     imgBaseUrl = 'http://192.168.10.158:8217';
//     baseUrl = 'http://192.168.10.158:8217/api';
//     // imgBaseUrl = 'http://192.168.11.44:8817';
//     // baseUrl = 'http://192.168.11.44:8817/api';
//     // console.log('development=======' + process.env.NODE_ENV)
// } else if (process.env.NODE_ENV == 'production') {
//     // imgBaseUrl = BASEURL || 'http://192.168.10.158:8217';
//     // baseUrl = (BASEURL + '/api') || 'http://192.168.10.158:8217/api';
//     imgBaseUrl = BASEURL;
//     baseUrl = BASEURL + '/api';
//     // console.log('production=======' + process.env.NODE_ENV)
// }
// 
// 
// 
// 
// 
// 
imgBaseUrl = IMG_BASE_URL;
baseUrl = BASEURL + '/api';

// if (process.env.NODE_ENV == 'development') {
// 	// 	imgBaseUrl = 'http://www.tibetmuseum.com.cn/';
// 	// baseUrl = 'http://www.tibetmuseum.com.cn/api';
// 	imgBaseUrl = 'https://xzwww.hengdawenbo.com';
// 	baseUrl = 'https://xzwww.hengdawenbo.com/api';
// } else if(process.env.NODE_ENV == 'production') {
// 	imgBaseUrl = '';
// 	baseUrl = '/api';
// 	// imgBaseUrl = 'http://192.168.10.158:8217';
// 	// baseUrl = 'http://192.168.10.158:8217/api';
// }
// 
// imgBaseUrl = 'http://192.168.10.158:8217';
// baseUrl = 'http://192.168.10.158:8217/api';
export {
    baseUrl,
    routerMode,
    imgBaseUrl,
}